import App from 'app/app.js';
import 'app/store/JobStore.js';

function CurrencyLocaleFilter($filter, $location, JobStore) {
  var host = null,
    jobCurrency = null;

  var currency = $filter('currency');

  var lookup = [
    ['COM', 'USD', '$'],
    ['COM', 'CAD', 'CAD'],
    ['CA', 'USD', 'USD'],
    ['CA', 'CAD', '$']
  ];

  var symbol = '$';

  return function (amount) {
    if (JobStore.hasJobsLoaded()) {
      var currentJob = JobStore.getJob();

      if (!!currentJob) {
        var currentHost = $location.host();
        var currentJobCurrency = currentJob.currency;

        if (host !== currentHost || jobCurrency !== currentJobCurrency) {
          host = currentHost;
          jobCurrency = currentJobCurrency;

          /*jslint regexp: true*/
          var tld = host.match(/[^.]+$/)[0].toUpperCase();
          /*jslint regexp: false*/

          var entry = R.find(function (e) {
            return tld === e[0] && jobCurrency === e[1];
          }, lookup);

          if (entry) {
            symbol = entry[2];
          }
        }
      }
    }
    return currency(amount, symbol);
  };
}

App.filter('CurrencyLocaleFilter', ['$filter', '$location', 'JobStore', CurrencyLocaleFilter]);
